import React from 'react';
import { createUseStyles } from 'react-jss';

import BackgroundImage from '../../components/BackgroundImage';

export interface CoverProps {
  src: string;
}

const Cover: React.FC<CoverProps> = ({ src }) => {
  const classes = useStyles();
  return (
    <div className={classes.coverBox}>
      <BackgroundImage src={src} resizeMode="cover" height="300px" />
    </div>
  );
};

const useStyles = createUseStyles({
  coverBox: {
    borderRadius: '15px',
    overflow: 'hidden',
    backgroundColor: '#eeeeee',
  },
});

export default Cover;
